import React, { Component } from 'react';
import moment from 'moment';
import { Row, Col, Tooltip, Button, Input, Form, Icon, Card, Divider, Alert } from 'antd';
import { VIEWS } from '../../../utils/yourAccountUtils';
import validator from 'validator';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import {Link, withRouter} from 'react-router-dom';

const { setEnvPrefix } = ssCommonUtils;

const
requirementMsgs = [
    'Minimum length of 12 characters',
    'At least one upper-case letter',
    'At least one lower-case letter',
    'At least one number',
    'At least one special character (such as: * & $ % ^ ( ) # @ ! ~)',
    'Not the same as your 10 previously used passwords'
],
requirementNotice = (c, m) => (
    <div>
        <Row>
            <Col span={2} style={{ color: `${c ? 'green' : 'red'}` }}>
                {c ? (
                    <div>
                        <div style={{
                            display: 'inline-block',
                            position: 'absolute',
                            marginLeft: '-22px'
                        }}>
                            {'OK'}
                        </div>
                        <Icon type='check-circle' />
                    </div>

                ) : (
                    <div style={{ display: 'inline-block' }}>
                        <Icon type='close-circle' />
                    </div>
                )}
            </Col>
            <Col span={22}>
                {m}
            </Col>
        </Row>
    </div>
),
validatorIs = (f, v, a) => {
    a = a != null ? a : true;
    if(v.length > 0)
        for(let i=0; i < v.length; i++)
            if(a) {
                if(validator.isAlpha(v.charAt(i)) && validator[f](v.charAt(i)))
                    return true;
            } else {
                if(validator[f](v.charAt(i)))
                    return true;
            }
    return false;
},
validationRules = {
    // Return 'true' as passings and 'false' as failing.
    hasMinLength: v => (v.length >= 12),
    hasUppercase: v => validatorIs('isUppercase', v),
    hasLowercase: v => validatorIs('isLowercase', v),
    hasNumber: v => validatorIs('isNumeric', v, false),
    hasSpecial: v => {
        for(let x=0; x < v.length; x++) {
            let
            isAlpha = validatorIs('isAlpha', v.charAt(x), false),
            isNumeric = validatorIs('isNumeric', v.charAt(x), false);
            if(!isAlpha && !isNumeric) return true;
        }
        return false;
    }
};

class DataEntry extends Component {
    constructor(props) { super(props); }

    isValid(v) {
        let result = {};
        for(let p in validationRules)
            result[p] = validationRules[p](v);

        for(let p in result)
            if(!result[p])
                return false;

        return true;
    }

    handleUpdate(e) {
        const
        { value } = e.target,
        p = this.props,
        { name, services, controls, formItemProps } = p,
        helpMsg = <Icon type='check-circle' />;

        let
        setValid = false,
        newFormItemsProps = {},
        valid = false;

        if(value.length > 0) {
            switch(name) {
                case 'newPassword1':
                    valid = this.isValid(value);
                    setValid = true;
                    if(value !== p.newPassword2)
                        newFormItemsProps.newPassword1 = {
                            validateStatus: 'warning',
                            help: 'Password does not match.'
                        };
                    else if(value === p.newPassword2)
                        newFormItemsProps = {
                            newPassword1: {
                                validateStatus: 'success',
                                help: helpMsg
                            },
                            newPassword2: {
                                validateStatus: 'success',
                                help: helpMsg
                            }
                        };
                    break;
                case 'newPassword2':
                    if(value !== p.newPassword1)
                        newFormItemsProps.newPassword2 = {
                            validateStatus: 'warning',
                            help: 'Password does not match.'
                        };
                    else if(value === p.newPassword1)
                        newFormItemsProps = {
                            newPassword1: {
                                validateStatus: 'success',
                                help: helpMsg
                            },
                            newPassword2: {
                                validateStatus: 'success',
                                help: helpMsg
                            }
                        };
                    break;
            }
        } else if(value.length === 0) {
            switch(name) {
                case 'newPassword1':
                    setValid = true;
                    newFormItemsProps.newPassword1 = {
                        validateStatus: '',
                        help: ''
                    }
                    if(formItemProps.newPassword2.validateStatus === 'success')
                        newFormItemsProps.newPassword2 = {
                            validateStatus: 'warning',
                            help: 'Password does not match.'
                        }
                    break;
                case 'newPassword2':
                    newFormItemsProps.newPassword2 = {
                        validateStatus: '',
                        help: ''
                    }
                    if(formItemProps.newPassword1.validateStatus === 'success')
                        newFormItemsProps.newPassword1 = {
                            validateStatus: 'warning',
                            help: 'Password does not match.'
                        };
                    break;
            }
        }

        controls.updateState({
            valid: setValid ? valid : this.props.valid,
            formItemProps: newFormItemsProps
        });
        services.updateDataEntry(e);
    }

    render() {
        const { text, name, formItemProps } = this.props;
        return (
            <Col span={7}>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={24} style={{ lineHeight: '16px' }}>
                        <span style={{ fontWeight: 'bold', fontStyle: 'italic', fontSize: '11px' }}>
                            {`${text}:`}
                        </span>
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={24} style={{ lineHeight: '30px' }}>
                        <Form.Item {...formItemProps[name]}>
                            <Input
                                id={`header-user-controls-${name}`}
                                type='password'
                                size='small'
                                autocomplete='off'
                                value={this.props[name]}
                                onChange={e => this.handleUpdate(e)}
                                name={name}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
        );
    }
}

export default class ChangePassword extends Component {
    state = {
        notifications: null,
        valid: null,
        formItemProps: {
            oldPassword: {
                validateStatus: '',
                help: ''
            },
            newPassword1: {
                validateStatus: '',
                help: ''
            },
            newPassword2: {
                validateStatus: '',
                help: ''
            }
        }
    }

    constructor(props) {
        super(props);
        this.updateState = this.updateState.bind(this);
    }

    updateFormItemProps() {
        const
        arg = arguments[0],
        { formItemProps } = this.state,
        { oldPassword, newPassword1, newPassword2 } = formItemProps;
        return {...formItemProps,
            oldPassword: arg.hasOwnProperty('oldPassword') ? arg.oldPassword : oldPassword,
            newPassword1: arg.hasOwnProperty('newPassword1') ? arg.newPassword1 : newPassword1,
            newPassword2: arg.hasOwnProperty('newPassword2') ? arg.newPassword2 : newPassword2
        };
    }

    updateState() {
        const { formItemProps, valid } = arguments[0];
        this.setState({...this.state,
            valid: valid,
            formItemProps: formItemProps != null
                ? this.updateFormItemProps(formItemProps)
                : {...this.state.formItemProps},
        });
    }

    handleSave() {
        const
        p = this.props,
        { services, oldPassword, newPassword1, newPassword2 } = this.props,
        { jti } = window.session;

        if(oldPassword.length > 0 && newPassword1.length > 0 && newPassword2.length > 0) {
            if(newPassword1 === newPassword2) {
                this.setState({...this.state, notifications: (
                    <div style={{ position: 'absolute', top: '15px', left: '10px' }}>
                        <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
                            <Icon type='loading' />
                            {' Updating password...'}
                        </span>
                        <div style={{ fontSize: '9px', marginTop: '4px' }}>
                            <span style={{ fontStyle: 'italic' }}>
                                {`Last Updated: ${moment({}).format('YYYY-MM-DD HH:mm:ss')}`}
                            </span>
                        </div>
                    </div>
                )});
                services.updatePassword({ oldPassword, newPassword: newPassword1 });
            }
        }
    }

    injectProps() {
        let keyPrefix = 'your-account-change-passowrd-data-entry-';
        return Array.from(arguments).map((e, i) => React.cloneElement(e, {...this.props,
            key: `${keyPrefix}${i}`,
            valid: this.state.valid,
            formItemProps: this.state.formItemProps,
            controls: { updateState: this.updateState }
        }));
    }

    componentDidUpdate(prev) {
        const
        { services } = this.props,
        prevPasswordStatus = prev.requests.updatePassword.status,
        currPasswordStatus = this.props.requests.updatePassword.status,
        currPasswordCode = this.props.requests.updatePassword.code,
        INVALID_OLD_PASSWORD = 451,
        PASSWORD_HISTORY_ERROR = 400;

        if(prevPasswordStatus === 'pending' && prevPasswordStatus !== null) {
            let icon = '', msg = '';
            switch(currPasswordStatus) {
                case 'success':
                    icon = 'check-circle-o';
                    msg = 'Update Successful.';
                    break;
                case 'failure':
                    icon = 'close-circle-o';
                    if(currPasswordCode === INVALID_OLD_PASSWORD) msg = 'Invalid old password.';
                    else if(currPasswordCode === PASSWORD_HISTORY_ERROR) msg = 'Password found in history.';
                    else if(currPasswordCode == null) msg = 'Unable to update.';
                    break;
            }
            services.resetPasswordUpdateRequest();
            this.setState({...this.state,
                valid: null,
                notifications: (
                    <div style={{ position: 'absolute', top: '15px', left: '10px' }}>
                        <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
                            <Icon type={icon} />
                            {` ${msg}`}
                        </span>
                        <div style={{ fontSize: '9px', marginTop: '4px' }}>
                            <span style={{ fontStyle: 'italic' }}>
                                {`Last Updated: ${moment({}).format('YYYY-MM-DD HH:mm:ss')}`}
                            </span>
                        </div>
                    </div>
                ),
                formItemProps: {
                    oldPassword: currPasswordCode === INVALID_OLD_PASSWORD ? {
                        validateStatus: 'error',
                        help: 'Invalid old password.'
                    } : {
                        validateStatus: '',
                        help: ''
                    },
                    newPassword1: {
                        validateStatus: '',
                        help: ''
                    },
                    newPassword2: {
                        validateStatus: '',
                        help: ''
                    }
                }
            });
        }
    }

    render() {
        const
        p = this.props,
        { loading, services } = p,
        { valid } = this.state,
        { notifications } = this.state;

        return (
            <div>
                {notifications}
                <div style={{ position: 'absolute', top: '68px', right: '10px' }}>
                    <Tooltip placement='left' title='Update password.'>
                        <Button
                            size='small'
                            icon='save'
                            type='primary'
                            style={{ width: '74px', borderRadius: '20px' }}
                            onClick={() => this.handleSave()}
                            disabled={
                                !valid &&
                                p.oldPassword.length === 0 &&
                                p.newPassword1.length === 0 &&
                                p.newPassword2.length === 0
                                    ? true :
                                    valid &&
                                    p.oldPassword.length > 0 &&
                                    p.newPassword1.length > 0 &&
                                    p.newPassword2.length > 0 &&
                                    p.newPassword1 === p.newPassword2
                                        ? false : true
                            }
                        >
                            {'Save'}
                        </Button>
                    </Tooltip>
                </div>
                <div style={{ position: 'absolute', top: '68px', left: '10px' }}>
                    <Tooltip placement='right' title='Close security questions.'>
                        <Button
                            icon='arrow-left'
                            shape='circle'
                            onClick={() => services.changeView(VIEWS.YOUR_ACCOUNT, [
                                { field: 'oldPassword', value: '' },
                                { field: 'newPassword1', value: '' },
                                { field: 'newPassword2', value: '' }
                            ])}
                        />
                    </Tooltip>
                </div>
                <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '20px' }}>
                    <Col span={p.noIcon ? 16 : 24} style={{ lineHeight: '18px' }}>
                        <Card
                            bordered={false}
                            style={{ textAlign: 'center' }}
                            bodyStyle={{ padding: '15px', borderRadius: '10px' }}
                        >
                            <Divider type='horizontal' style={{ margin: '0px 0px 10px 0px' }}>
                                <div style={{ display: 'inline-block' }}>
                                    <Alert
                                        showIcon
                                        iconType={valid == null ? 'info-circle-o' : valid ? 'check-circle-o' : 'close-circle-o'}
                                        type={valid == null ? 'info' : valid ? 'success' : 'error'}
                                        message="Password Requirements"
                                        style={{ fontStyle: 'italic', fontWeight: 'bold' }}
                                    />
                                </div>
                            </Divider>
                            <div style={{ textAlign: 'left', lineHeight: '15px', marginLeft: p.noIcon ? '14%' : '25%' }}>
                                {requirementMsgs.map((m, i) => (
                                    <Row key={`password-requirements-${i}`}>
                                        <Col span={24}>
                                            <span style={{ marginRight: '10px' }}>
                                                <Icon type='swap-right' />
                                            </span>
                                            {m}
                                        </Col>
                                    </Row>
                                ))}
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '-14px' }}>
                    {this.injectProps(
                        <DataEntry text={'Old Password'} name='oldPassword' />,
                        <DataEntry text={'New Password'} name='newPassword1' />,
                        <DataEntry text={'Re-type New Password'} name='newPassword2' />
                    )}
                </Row>
            </div>
        );
    }
}
